import { css } from "@emotion/css";

import { FontSizes } from "@/assets/fonts.ts";
import { AtomProps } from "@/uiKit/atoms/utils/AtomTypes.ts";

export type BaseRichTextToggleButtonsProps = {
  toggled: boolean;
  onToggle: () => void;
};

export type RichTextToggleButtonsProps = AtomProps<BaseRichTextToggleButtonsProps>;

export const toggleButtonStyles = {
  icon: css({
    width: FontSizes.bodyLarge,
    height: FontSizes.bodyLarge,
  }),
};
